export default __webpack_public_path__ + "static/media/PowellCatLocation-12.0772f217.jpg";